import { FC } from 'react'

import { Card, CardContent, CardFooter, Cluster, Grid, GridItem, Skeleton, Stack } from '@forto-dev/phoenix-ui-core'

export const ReportsSkeleton: FC = () => {
  return (
    <Stack gap={16}>
      <Grid col={5}>
        <Skeleton variant="badge" fullWidth />
      </Grid>
      <Grid col={3} gap={16} breakpoint="sm">
        {Array.from({ length: 3 }).map((_, index) => (
          <Card key={index}>
            <CardContent>
              <Stack gap={24}>
                <Cluster gap={8} fullWidth>
                  <Skeleton variant="avatar" />
                  <Stack gap={4} fullWidth>
                    <Skeleton variant="badge" fullWidth />
                    <Skeleton variant="content" fullWidth />
                  </Stack>
                </Cluster>
                <Cluster />
              </Stack>
              <Cluster gap={8}>
                <Skeleton variant="button" />
                <Skeleton variant="button" />
              </Cluster>
            </CardContent>
            <CardFooter>
              <Grid col={12}>
                <GridItem span={8}>
                  <Cluster />
                </GridItem>
                <GridItem span={2}>
                  <Skeleton variant="button" />
                </GridItem>
                <GridItem span={2}>
                  <Skeleton variant="button" />
                </GridItem>
              </Grid>
            </CardFooter>
          </Card>
        ))}
      </Grid>
    </Stack>
  )
}
